<div class="base-card">
    <div class="base-card__header">
        <div class="base-card__header-left">
            <dsy-heading level="h2" level-size="xl" level-style="bold"> {{ title() }}</dsy-heading>
            @if (subtitle()) {
                <p class="base-card__header-subtitle">{{ subtitle()}}</p>
            }
            <ng-content select="[header-bottom]"></ng-content>
        </div>
        <ng-content select="[header-right]"></ng-content>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>